export const googlePlayServiceAccounts = [
    "google-play-console-1",
    "google-play-console-2",
    "google-play-console-3"
]